import React from 'react';

const ReadyToLeaveIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.5 3V6M16.5 3V6M8.5 11.5H7.5M8.5 15H7.5M12.5 11.5H11.5M12.5 15H11.5M16.5 11.5H15.5M16.5 15H15.5M6 4.5H18C19.6569 4.5 21 5.84315 21 7.5V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V7.5C3 5.84315 4.34315 4.5 6 4.5Z"
            stroke="#1F2F3B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ReadyToLeaveIcon;
